import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { image } from '@cloudinary/transformation-builder-sdk/qualifiers/source';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-crop',
  templateUrl: './crop.component.html',
  styleUrls: ['./crop.component.scss']
})
export class CropComponent implements OnInit {

  public data: any;
  public loading: boolean = false;
  public aspectRatio: number = 430 / 675;
  public imageChangedEvent?: ImageCroppedEvent;

  constructor(
    private dialogRef: MatDialogRef<CropComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      image: any,
      type: String
    },
  ) {
    this.data = data;
    if (this.data.type === 'signal_template_background') {
      this.aspectRatio = 430 / 675;
    } else if (this.data.type === 'signal_template_logo') {
      this.aspectRatio = 430 / 130;
    }
  }

  ngOnInit(): void {
    
  }

  imageCropped(event: ImageCroppedEvent) {
      this.imageChangedEvent = event;
  }

  done() {
    this.dialogRef.close({
      image: this.data.image,
      croppedImage: this.imageChangedEvent
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  /*
  {
      "image": {
          "asset_id": "89ad7925bd3bf30e9e8a73e88bc49a84",
          "public_id": "lhpe/development/91/44/xpuhhthyefvpp4sbg9n2",
          "version": 1715276105,
          "version_id": "27c7ddd70f0fd1a809052d2935849462",
          "signature": "22c23f076d2ca6ba7ee246ec0899ed27f66c1d84",
          "width": 1024,
          "height": 1024,
          "format": "png",
          "resource_type": "image",
          "created_at": "2024-05-09T17:35:05Z",
          "tags": [],
          "bytes": 3162696,
          "type": "upload",
          "etag": "1618594c0acce754fd64877e20016ca7",
          "placeholder": false,
          "url": "http://res.cloudinary.com/hud9ala09/image/upload/v1715276105/lhpe/development/91/44/xpuhhthyefvpp4sbg9n2.png",
          "secure_url": "https://res.cloudinary.com/hud9ala09/image/upload/v1715276105/lhpe/development/91/44/xpuhhthyefvpp4sbg9n2.png",
          "folder": "lhpe/development/91/44",
          "access_mode": "public",
          "original_filename": "img-D16rtDVNrMnVzWT8nKtuM0fM",
          "api_key": "234758833681514",
          "full_prompt": "A disgustingly overcrowded toilet bowl, where a colossal pile of dirty and stained underwear has been haphazardly stuffed, resulting in articles of clothing poking out at quirky angles. The ceramic toilet is simple and slightly dull, not particularly fancy. The light in the closed space glimmers weakly on the unfitting sight, highlighting the disarray and sense of an urgent need of cleaning."
      },
      "type": "signal_template_background"
  }
  */

}
